import { useProfile } from '../api/queries/useProfile';
import { getI18nInstance } from '../i18n';

import type { SupportedCountry } from '../types/supported-countries';

export const useCountryFromLocale = (): SupportedCountry | undefined => {
  const { data: profile } = useProfile();

  const lang = getI18nInstance().language;
  if (lang) {
    return (['de', 'fr', 'nl'].includes(lang) ? lang : 'nl') as SupportedCountry;
  }

  switch (profile?.result?.locale) {
    case 'nl_NL':
      return 'nl';
    case 'de_DE':
      return 'de';
    case 'fr_FR':
      return 'fr';
    default:
      return undefined;
  }
};
